(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_4780a69"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
  const header = event.target.closest('[class*="ai-service-accordion-header-"]');
  if (!header) return;

  const item = header.closest('[class*="ai-service-accordion-item-"]');
  const accordion = header.closest('[class*="ai-services-mobile-accordion-"]');

  if (!item || !accordion) return;

  const wasActive = item.classList.contains('active');

  accordion
    .querySelectorAll('[class*="ai-service-accordion-item-"]')
    .forEach(function (otherItem) {
      otherItem.classList.remove('active');
    });

  if (!wasActive) {
    item.classList.add('active');
  }
});
document.addEventListener('mouseover', function (event) {
  const card = event.target.closest('[class*="ai-service-card-"]');
  if (!card) return;

  card.style.transform = 'translateY(-10px) scale(1.02)';
  card.style.boxShadow = '0 16px 34px rgba(0,0,0,0.16)';
});

document.addEventListener('mouseout', function (event) {
  const card = event.target.closest('[class*="ai-service-card-"]');
  if (!card) return;

  if (card.contains(event.relatedTarget)) return;

  card.style.transform = '';
  card.style.boxShadow = '';
});
  } catch(e) { console.error(e); }
})();

})();
